import * as yup from 'yup';
import Regex from 'common/constants/regex';


const userSchemaObject = {
  name: yup
    .string()
    .required('common.form.error.required')
    .min(3, 'user.error.name.min')
    .max(30, 'user.error.name.max'),
  
  password: yup
    .string()
    .required('common.form.error.required')
    .min(6, 'user.error.password.min'),
  
  
  password_confirmation: yup.string()
    .oneOf([yup.ref('password'), null], 'user.password.confirm.error'),
  
  email: yup
    .string()
    .matches(Regex.EMAIL,
      ({ originalValue, value }) => {
        if (!!originalValue === false) {
          return 'common.form.error.required';
        } else if (!Regex.EMAIL.test(value)) {
          return 'user.error.email.invalid';
        }
      },
    ),
};

export default function getUserValidationSchema (arrayOfKeys) {
  const keys = arrayOfKeys.length === 0 ? Object.keys(userSchemaObject) : arrayOfKeys;
  
  const shape = keys.reduce((output, currentKey) => {
    output[currentKey] = userSchemaObject[currentKey];
    return output;
  }, {});
  
  return yup.object().shape(shape);
}
